
import RegisterPage from '../components/Register/Register';

export default function Register() {
  return <RegisterPage />;
}
